import _ from "lodash";
import {appConfig} from "../../firebase/client-app";
import {extractColorsFromDesignVariant} from "./design-variant-util";

export {
    prepareDesignTags
}

const prepareDesignTags = (allTags, designDetail, parentProduct, quoteDetail, designVariantDetail, imagesList) => {
    let designTagDetailList = [];
    let tagDetailList = [];
    let redBubbleTagDetailList = [];
    const allTagsMap = _.keyBy(allTags, 'id');

    const appSocialName = appConfig?.appSocialName;

    if (appSocialName) {
        const appSocialNameTag = {
            startText: appSocialName
        }

        tagDetailList.push(appSocialNameTag);
        redBubbleTagDetailList.push(appSocialNameTag);
    }

    const quoteTag = {
        startText: designDetail?.quoteName
    }

    const themeTag = {
        startText: designDetail?.themeName
    }

    const parentTag = {
        startText: designDetail?.parent
    }

    const productTypeTag = {
        startText: designDetail?.productType
    }

    const categoryTag = {
        startText: designDetail?.category
    }

    tagDetailList.push(quoteTag);
    tagDetailList.push(themeTag);
    tagDetailList.push(parentTag);
    tagDetailList.push(productTypeTag);
    tagDetailList.push(categoryTag);

    redBubbleTagDetailList.push(quoteTag);
    redBubbleTagDetailList.push(themeTag);

    designTagDetailList.push(quoteTag);
    designTagDetailList.push(themeTag);
    designTagDetailList.push(parentTag);
    designTagDetailList.push(productTypeTag);
    designTagDetailList.push(categoryTag);

    if (designVariantDetail) {
        _.forEach(designVariantDetail?.tagList, (tagId) => {
            tagDetailList.push(allTagsMap[tagId]);
            redBubbleTagDetailList.push(allTagsMap[tagId]);
        });

        _.forEach(designVariantDetail?.colors, color => {
            tagDetailList.push({
                startText: color?.name
            });
        });
    }

    _.forEach(parentProduct?.tagList, (tagId) => {
        tagDetailList.push(allTagsMap[tagId]);
        designTagDetailList.push(allTagsMap[tagId]);
    });

    _.forEach(quoteDetail?.tagList, (tagId) => {
        tagDetailList.push(allTagsMap[tagId]);
        redBubbleTagDetailList.push(allTagsMap[tagId]);
        designTagDetailList.push(allTagsMap[tagId]);
    });

    _.forEach(designDetail?.tagList, (tagId) => {
        tagDetailList.push(allTagsMap[tagId]);
        redBubbleTagDetailList.push(allTagsMap[tagId]);
        designTagDetailList.push(allTagsMap[tagId]);
    });

    if (imagesList) {
        const imagesMap = _.keyBy(imagesList, 'id');
        _.forEach(designVariantDetail?.images, image => {
            const imageDetail = imagesMap[image?.id];

            if (!image?.isTemplate && imageDetail) {
                _.forEach(imageDetail?.tagList, (tagId) => {
                    tagDetailList.push(allTagsMap[tagId]);
                    redBubbleTagDetailList.push(allTagsMap[tagId]);
                });
            }
        });
    }

    if (designVariantDetail) {
        tagDetailList = _.concat(tagDetailList, extractColorsFromDesignVariant(designVariantDetail));
        redBubbleTagDetailList = _.concat(redBubbleTagDetailList, extractColorsFromDesignVariant(designVariantDetail));
    }

    return {
        tagDetailList,
        redBubbleTagDetailList,
        designTagDetailList,
    };
}
